import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { faqs } from '@/mocks/home';

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          align="center"
          eyebrow="常见问题"
          title="关于瓜田，你可能想问这些"
          desc="第一次来的话，先看这几条，基本就能摸清我们在做什么、怎么做。"
        />

        <div className="mt-10 md:mt-14 max-w-3xl mx-auto flex flex-col gap-3">
          {faqs.map((faq) => {
            const open = openId === faq.id;
            return (
              <div
                key={faq.id}
                className={`rounded-lg border transition-colors ${
                  open ? 'bg-background-50 border-primary-300' : 'bg-background-50 border-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? null : faq.id)}
                  aria-expanded={open}
                  className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left"
                >
                  <span className="font-heading text-base md:text-lg text-foreground-950">{faq.q}</span>
                  <i
                    className={`flex-shrink-0 text-xl text-primary-600 transition-transform ${
                      open ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  />
                </button>
                {open && (
                  <p className="px-4 md:px-5 pb-4 md:pb-5 -mt-1 text-sm leading-relaxed text-foreground-600">
                    {faq.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
    </section>
  );
}